import { render, staticRenderFns } from "./v-page-container.vue?vue&type=template&id=4a02a835&scoped=true&"
import script from "./v-page-container.vue?vue&type=script&lang=js&"
export * from "./v-page-container.vue?vue&type=script&lang=js&"
import style0 from "./v-page-container.vue?vue&type=style&index=0&id=4a02a835&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a02a835",
  null
  
)

export default component.exports